import { useState, useEffect, useRef, useCallback } from 'react';
import { getAuthToken, getWhatsAppBridgeStatus } from '../api/client';

export type WhatsAppStatus = 'disconnected' | 'connecting' | 'qr_ready' | 'connected';

export function useWhatsAppStatus() {
  const [status, setStatus] = useState<WhatsAppStatus>('disconnected');
  const [loading, setLoading] = useState(true);
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetchStatus = useCallback(async () => {
    // Skip polling if user is not authenticated
    if (!getAuthToken()) {
      setStatus('disconnected');
      setLoading(false);
      return;
    }
    try {
      const data = await getWhatsAppBridgeStatus();
      setStatus(data.status);
    } catch {
      setStatus('disconnected');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
    pollRef.current = setInterval(fetchStatus, 5000);
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [fetchStatus]);

  return { status, loading };
}
